import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {  categoryList} from "../apis/apiHandler";

export const category = createAsyncThunk(
    "Category/list",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await categoryList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);


const initialState = {
    loading: false,
    categoryList: [],
    error: null,
    success: false,
};

const categorySlice = createSlice({
    name: "category",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(category.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(category.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.categoryList = payload;
                state.success = true;
            })
            .addCase(category.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default categorySlice.reducer;
